/***
*
*   STORAGE USAGE
*   Displays storage usage with progress bar and threshold indicators
*
**********/

import { Card } from 'components/lib';
import Style from './dashboard.tailwind.js';

export function StorageUsage(props) {
  const { 
    used = 0, 
    allocated = 0, 
    usagePercent = 0, 
    overQuotaCount = 0, 
    loading 
  } = props;
  
  // Convert bytes to GB if values are large, otherwise assume MB
  const formatStorage = (value) => {
    if (value >= 1024) {
      return (value / 1024).toFixed(2) + ' GB';
    }
    return value + ' MB';
  };
  
  const percentage = usagePercent || (allocated > 0 ? Math.min((used / allocated) * 100, 100) : 0);
  
  // Determine threshold status
  const getThresholdStatus = (pct) => {
    if (pct >= 90) return 'critical';
    if (pct >= 75) return 'warning';
    return 'normal';
  };
  
  const status = getThresholdStatus(percentage);
  
  const getProgressClass = () => {
    const base = Style.progressBar;
    if (status === 'critical') return `${base} ${Style.progressCritical}`;
    if (status === 'warning') return `${base} ${Style.progressWarning}`;
    return `${base} ${Style.progressNormal}`;
  };

  return (
    <Card title="Storage Usage" loading={loading}>
      <div className={Style.storageContainer}>
        <div className={Style.storageHeader}>
          <span className={Style.storageUsed}>{formatStorage(used)}</span>
          {allocated > 0 && (
            <span className={Style.storageAllocated}>/ {formatStorage(allocated)}</span>
          )}
        </div>
        
        <div className={Style.progressContainer}>
          <div 
            className={getProgressClass()} 
            style={{ width: `${Math.max(percentage, 2)}%` }}
          />
        </div>
        
        <div className={Style.storageFooter}>
          <span className={Style.percentage}>{percentage.toFixed(1)}% used</span>
          {overQuotaCount > 0 && (
            <span className={Style.criticalText}>
              🚨 {overQuotaCount} org(s) over quota
            </span>
          )}
          {status === 'warning' && overQuotaCount === 0 && (
            <span className={Style.warningText}>⚠️ Approaching limit</span>
          )}
          {status === 'critical' && overQuotaCount === 0 && (
            <span className={Style.criticalText}>🚨 Critical - Action required</span>
          )}
        </div>
      </div>
    </Card>
  );
}